export default {
  permissions: [],
  requestStatus: 'idle',
  usersWithRoles: false
};
